import multipleOrganizationsSelection from './MultipleSelections/multipleOrganizationsSelection';
import multipleOrganizationChildSelected from './MultipleSelections/multipleOrganizationChildSelected';
import multipleFieldsSelection from './MultipleSelections/multipleFieldsSelection';
import Logger from '../../../../../../../../../utility/services/Logger';

const toAllowSelectSet = new Set(['letterBody', 'summary']);

export default (editor /* showError */) => {
  const {
    value: { anchorBlock, focusBlock },
    props: { sectionKey },
  } = editor;
  if (anchorBlock && focusBlock && !toAllowSelectSet.has(sectionKey)) {
    try {
      /**
       * When multiple organizations are selected - 2 work experiences
       */
      const isMultipleOrgSelection = multipleOrganizationsSelection(editor);
      if (isMultipleOrgSelection) return true;

      /**
       * When multiple organization childs are selected - organization details + role description
       */
      const isMultipleOrgChildSelection =
        multipleOrganizationChildSelected(editor);
      if (isMultipleOrgChildSelection) return true;

      /**
       * When multiple fields are selected - role description + achievement
       */
      const isMultipleFieldsSelection = multipleFieldsSelection(editor);
      if (isMultipleFieldsSelection) return true;
    } catch (err) {
      Logger.Log(err);
    }
  }

  return false;
};
